class StoreConstants {
  constructor() {
    this.commits = {
      setAccount: 'setAccount',
      setCredentials: 'setCredentials',
    }

    this.actions = {
      loadAccount: 'loadAccount'
    }
  }
}

export default (new StoreConstants())